// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PF1fe","largestCol":"styles_largestCol__3lqRu","smallestCol":"styles_smallestCol__3vKv6"};